import styled from 'styled-components'
//  views
import { Button } from 'components/Modals/SystemProcessModal/Form/components/Transactions/components/Transaction/components/SendEmail/components/EmailEditor/components/AddMetatagButton/views'

export const FieldWrapper = styled('div')<any>`
  display: flex;
  flex-direction: column;
  width: ${({ width }) => (width ? width : 'unset')};

  ${Button} {
    margin: 0 0 0 auto;
    position: unset;
    right: 0;
    top: 0;
  }
`
